import orderBy from 'lodash.orderby';

import { numberToDay, strToInterests, strToMonth } from '@/_containers';
import { nullableNumericToNumericStringConverter } from '@/_schemas/generic';
import { strToStatus } from '@/_schemas/status-input';
import { dateTime, sortByLatest } from '@/_shared';

import type { ContactFormSchema, ContactQuerySchema } from '../schemas';

export function contactQueryToForm(data: ContactQuerySchema): ContactFormSchema {
  return {
    ...data,
    id: data.id,
    last_name: data?.last_name ?? '',
    email: data?.email ?? '',
    title: data?.title ?? '',
    spouse_name: data?.spouse_name ?? '',
    children_names: data?.children_names ?? '',
    pet_names: data?.pet_names ?? '',

    birth_day: numberToDay(data.birth_day),
    birth_month: strToMonth(data.birth_month),
    work_anniversary: data?.work_anniversary ? dateTime.format(data?.work_anniversary, 'YYYY-MM-DD') : undefined,
    wedding_anniversary: data?.wedding_anniversary
      ? dateTime.format(data?.wedding_anniversary, 'YYYY-MM-DD')
      : undefined,

    interests: strToInterests(data.interests),
    twitter_handle: data?.twitter_handle ?? '',
    linked_in_url: data?.linked_in_url ?? '',
    status: strToStatus(data?.status),
    remote_worker: `${data?.remote_worker ?? 0}` as '0' | '1',
    friends: orderBy(data?.friends ?? [], ['first_name']),
    clients: orderBy(data?.clients ?? [], ['name']),
    phone_numbers: sortByLatest(data?.phone_numbers ?? []),
    freshdesk: nullableNumericToNumericStringConverter(data.freshdesk),
  };
}
